module.exports = __webpack_public_path__ + "img/text_charactor.112db28f.png";